package module.watchlist

import common.EEnvironmentVariables
import core.extensions.getValue
import core.io.dto.MinifiedColourDTO
import kotlinx.serialization.SerialName

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 14.10.22
 * Author : mariorosshirt
 */

@kotlinx.serialization.Serializable
data class ColourListObject(

    @SerialName("unique")
    val mUnique: String,

    @SerialName("name")
    val mName: String,

    @SerialName("artNr")
    val mArtNr: String,

    @SerialName("colourCode")
    val mColourCode: String,

    @SerialName("squareMeter")
    var mSquareMeter: Double?,

    @SerialName("isOwnColor")
    val mIsOwnColor: Boolean,

    @SerialName("colourCollection")
    val mColourCollection: String,

    @SerialName("additionalInfo1")
    val mAdditionalInfo1: String,

    @SerialName("additionalInfo2")
    val mAdditionalInfo2: String,

    @SerialName("eanCode")
    val mEanCode: String
) {
    val mImageUrl: String = "https://${EEnvironmentVariables.VEEUZE_HOST.getValue()}/api/getProductImage/$mUnique"

    val mInspirationImageUrl: String =
        "https://${EEnvironmentVariables.VEEUZE_HOST.getValue()}/api/getInspirationImage/$mUnique"
}

fun ColourListObject.toMinifiedColourDTO(): MinifiedColourDTO {
    return MinifiedColourDTO(mUnique, mName, mArtNr, mColourCode, mColourCollection, mAdditionalInfo1, mAdditionalInfo2, mEanCode)
}
